module.exports = __webpack_public_path__ + "static/media/pepe1.2709932b.png";